// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.form_group_create {
  padding: 10px;
  border: 1px solid gray;
  margin: 20px 0;
}

.select-sale-button {
  align-self: self-end;
}

#SalesCreate_component .select-box {
  display: block;
  background-color: #F4F4F4;
  padding: 5px 5px;
  border-radius: 5px;
  border-color: #F4F4F4;
}
#SalesCreate_component .modal .nav-tabs .nav-link.active,
#SalesCreate_component .modal .nav-item.show .nav-link.active {
  background-color: #8ba6eb !important;
  color: white !important;
  border-color: #8ba6eb !important;
}
#SalesCreate_component .modal form .form-group {
  margin-bottom: 1rem;
}
#SalesCreate_component .modal form .select-box {
  display: inline-block;
  background-color: #F4F4F4;
  padding: 5px 5px;
  border-radius: 5px;
  border-color: #F4F4F4;
  margin-left: 10px;
}
#SalesCreate_component .modal form .react-datepicker-wrapper .react-datepicker__input-container input {
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  padding: 0.375rem 0.75rem;
}

#SaleEditionAssignTaskTabs-tabpane-list .Assigned {
  color: orange;
}
#SaleEditionAssignTaskTabs-tabpane-list .Completed {
  color: green;
}

form .save-information-btn, #SaleWorkflowEditCAD_request_component .save-information-btn {
  padding: 5px 15px;
  background-color: black !important;
  border-color: black !important;
}
form .disagree-btn, #SaleWorkflowEditCAD_request_component .disagree-btn {
  padding: 5px 15px;
  background-color: #71CFD1 !important;
  border-color: #71CFD1 !important;
}
form .confirm-btn, #SaleWorkflowEditCAD_request_component .confirm-btn {
  padding: 5px 15px;
  margin-right: 20px;
  background-color: #8BA6EB !important;
  border-color: #8BA6EB !important;
}
form .request-cad-btn, #SaleWorkflowEditCAD_request_component .request-cad-btn {
  padding: 5px 15px;
  background-color: black !important;
  border-color: black !important;
  margin-right: 20px;
}

.previous_post_sale_count {
  color: orange;
}

.div-border-right-solid-2 {
  border-right: 3px #000 solid;
}`, "",{"version":3,"sources":["webpack://./src/css/sales/sale_create.scss"],"names":[],"mappings":"AAQA;EACI,aAAA;EACA,sBAAA;EACA,cAAA;AAPJ;;AASA;EACI,oBAAA;AANJ;;AASI;EACI,cAAA;EACA,yBAAA;EACA,gBAAA;EACA,kBAAA;EACA,qBAAA;AANR;AAYgB;;EACI,oCAAA;EACA,uBAAA;EACA,gCAAA;AATpB;AAcY;EACI,mBAAA;AAZhB;AAcY;EACI,qBAAA;EACA,yBAAA;EACA,gBAAA;EACA,kBAAA;EACA,qBAAA;EACA,iBAAA;AAZhB;AAgBoB;EACI,yBAAA;EACA,sBAAA;EACA,yBAAA;AAdxB;;AAuBI;EACI,aAAA;AApBR;AAsBI;EACI,YAAA;AApBR;;AAyBI;EACI,iBAAA;EACA,kCAAA;EACA,8BAAA;AAtBR;AAwBI;EACI,iBAAA;EACA,oCAAA;EACA,gCAAA;AAtBR;AAwBI;EACI,iBAAA;EACA,kBAAA;EACA,oCAAA;EACA,gCAAA;AAtBR;AAwBI;EACI,iBAAA;EACA,kCAAA;EACA,8BAAA;EACA,kBAAA;AAtBR;;AA0BA;EACI,aAAA;AAvBJ;;AA0BA;EACI,4BAAA;AAvBJ","sourcesContent":["$color_red_1: #FF9AA2;\n$color_red_2: #FFB7B2;\n$color_orange: #FFDAC1;\n$color_grass: #E2F0CB;\n$color_green: #B5EAD7;\n$color_purlple: #C7CEEA;\n$blue_link: #5673f8;\n$font_size_content: 13px;\n.form_group_create{\n    padding: 10px;\n    border: 1px solid gray;\n    margin: 20px 0;\n}\n.select-sale-button {\n    align-self: self-end;\n}\n#SalesCreate_component {\n    .select-box {\n        display: block;\n        background-color: #F4F4F4;\n        padding: 5px 5px;\n        border-radius: 5px;\n        border-color: #F4F4F4;\n    }\n    .modal {\n        .nav-tabs,\n        .nav-item.show {\n            .nav-link {\n                &.active {\n                    background-color: #8ba6eb !important;\n                    color: white !important;\n                    border-color: #8ba6eb !important;\n                }\n            }\n        }\n        form {\n            .form-group {\n                margin-bottom: 1rem;\n            }\n            .select-box {\n                display: inline-block;\n                background-color: #F4F4F4;\n                padding: 5px 5px;\n                border-radius: 5px;\n                border-color: #F4F4F4;\n                margin-left: 10px;\n            }\n            .react-datepicker-wrapper {\n                .react-datepicker__input-container {\n                    input {\n                        border: 1px solid #ced4da;\n                        border-radius: 0.25rem;\n                        padding: 0.375rem 0.75rem;\n                    }\n                }\n            }\n        }\n    }\n}\n\n#SaleEditionAssignTaskTabs-tabpane-list {\n    .Assigned {\n        color: orange;\n    }\n    .Completed {\n        color: green;\n    }\n}\n\nform, #SaleWorkflowEditCAD_request_component {\n    .save-information-btn {\n        padding: 5px 15px;\n        background-color: black !important;\n        border-color: black !important;\n    }\n    .disagree-btn {\n        padding: 5px 15px;\n        background-color: #71CFD1 !important;\n        border-color: #71CFD1 !important;\n    }\n    .confirm-btn {\n        padding: 5px 15px;\n        margin-right: 20px;\n        background-color: #8BA6EB !important;\n        border-color: #8BA6EB !important;\n    }\n    .request-cad-btn {\n        padding: 5px 15px;\n        background-color: black !important;\n        border-color: black !important;\n        margin-right: 20px;\n    }\n}\n\n.previous_post_sale_count {\n    color: orange;\n}\n\n.div-border-right-solid-2 {\n    border-right: 3px #000 solid;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
